<template>
    <v-app id="inspire">
      <Header type="search"/>
      <v-main class="grey lighten-3">
        <v-container>
          <v-row>
            <Menu/>
            <v-container class="col-11">
              <div v-if="isLoadingReport" style="position:absolute; left:42%; 
                top: 40vh;
                display: flex;
                align-items: center;
                justify-content: center;
            ">
              <v-progress-circular
                color="green"
                indeterminate
                style="width:200px; height:200px; z-index:999;"
              ></v-progress-circular>
            </div>
              <v-row>
                <v-col class="page-top d-flex justify-space-between" cols="12">
                  <div>
                    <div class="page-title">Отчеты отдела продаж</div>
                    <div class="breadcrumb" ref="myBtn">Отчеты отдела продаж</div>
                  </div>
                </v-col>
  
                <v-col cols="12">
                  <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                    <v-tabs
                        id="horizontal_tabs"
                        v-model="reportTab"
                        centered
                        class="reports-tabs"
                        height="40"
                    >
                      <v-tab v-for="item in reportType" :key="item.id" class="ml-4">
                        {{ item.name }}
                      </v-tab>
                    </v-tabs>
                  </v-sheet>
                </v-col>
                <v-col>
                  <v-tabs-items v-model="reportTab">
  
         
                    <!-- План факт -->
                    <v-tab-item>
                      <v-sheet class="rounded-lg border-gray">
                        <v-card-title class="d-flex justify-space-between align-center">
                          <div class="report-1 filter">
                            <div class="left">
                                <div class="item" style="">
                                  
                                  <VueDatePicker 
                                  v-if="filter && filter.date"
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>
                              </div>

                              <div class="item">
                                <v-btn dark class="filter-button" @click="reportGenerate(1)"
                                      :disabled="buttonDisabled">
                                  Сформировать
                                </v-btn>
                              </div>

                                
                          </div>

                            <div class="right">
                              <v-btn light class="special-light-button" :disabled="buttonDisabled"
                              @click="reportExport(1)">
                                <img src="/playground_assets/printer.svg" alt="">
                                Печать
                              </v-btn>
                            </div>
                          
                          </div>

                          <div class="report-1 filter" style="align-items: baseline;">
                    
                            
                            <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
  
                        
                                  <div style="width:100%;">
                                  
                                    <v-select class="rounded-lg custom__select" @change="setUit" v-model="lastUit"
                                              return-object
                                              :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                              placeholder="Подразделение" append-icon="mdi-chevron-down" outlined
                                              dense style="height: 48px;margin-top: 10px; width:100%;"
                                              >
                                    </v-select>
                                  </div>

                                  <div v-for="(line,index) of uitList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setUit(line)"> X </div>
                                  </div>

                                </div>

                                <div class="item" style="margin-right: 10px; display:flex; margin-left:20px;  margin-top: 20px; flex-direction: column; width:25%;">

                                    <v-select
                                                class="rounded-lg custom__select"
                                                v-model="lastManager"
                                                :items="specialist ? specialist.specialist : []"
                                                item-value="id"
                                                item-text="name"
                                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                                placeholder="Выбрать менеджера"
                                                append-icon="mdi-chevron-down"
                                                outlined
                                                dense
                                                return-object
                                                @change="setManager"
                                                style="height: 48px; max-width: 100%; width: 100%">
                                            </v-select>

                                    <div v-for="(line,index) of managerList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                        <div >{{ index+1 }}. {{line.name}}</div>
                                        <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setManager(line)"> X </div>
                                    </div>

                                </div>

                          </div>
                        </v-card-title>
  
                        <div class="scroll-table">
                          <table id="table-5" cellpadding="1">
                            <thead>
                            <tr>
                              <th></th>
                              <th class="font-bold">Подразделение</th>
                 
                              <th rowspan="2" class="font-bold no-wrap">План продаж
                              </th>
                              <th rowspan="2" class="font-bold no-wrap">Факт продаж
                              </th>
                              <th rowspan="2" class="font-bold no-wrap">План выполнен
                              </th>
                            </tr>
                            <tr>
                              <th></th>
                              <th class="font-bold">Продавец</th>
                     
                            </tr>
                            </thead>
  
                            
                            <tbody>
                            <template v-if="report_new_1 && report_new_1.column1">
                              <template v-for="(line,index) of report_new_1.column1">
                                <tr class=""
                                  :key="index"
                                  >
                                  <td>
                                    <template v-if="line.children && line.children.length > 0">
                                      <button
                                          :class="{ 'open-hide': true, open: openParentLine.includes(line[0].column1.id) }"
                                          @click="openChildren(line[0].column1.id)"></button>
                                    </template>
                                  </td>
                                  <td>{{ line[1].column1.name }}</td>
                                  <td>{{ line[0].line1 }}</td>
                                  <td>{{ line[0].line2 }}</td>
                                  <td>{{ line[0].line3 ? 'да' : 'нет' }}</td>
                                </tr>
                                <template v-if="line.children && line.children.length > 0">
                                  <template v-for="(children2,index2) of line.children">
                                    <tr v-if="openParentLine.includes(line[0].column1.id)"
                                        :key="index2+'0-062'"
                                        :class="{ children: true, open: openParentLine.includes(line[0].column1.id) }">
                                      <td></td>
                                      <td>{{ children2.column2.name }}</td>
                                      <td>{{ children2.line1 }}</td>
                                      <td>

                                        <div v-if="line[0].column1.id" style="cursor:pointer;" @click="getReport1Detail(line[0].column1.id,children2.column2.id,children2.column2.name)">
                                            {{ children2.line2 }}

                                            <v-progress-circular
                                                    v-if="isLoadingReport"
                                                    color="green"
                                                    indeterminate
                                                    style="width:20px; height:20px;"
                                                ></v-progress-circular>
                                        </div>
                                        <div v-else>
                                            {{ children2.line2 }}
                                        </div>
                                    
                                        </td>
                                      <td>{{ children2.line3 ? 'да' : 'нет' }}</td>
                                    </tr>
                                    
                                  </template>
                                  
                                </template>
                                
                              </template>
                              <tr class="parrent" v-if="report_new_1 && report_new_1.res && report_new_1.res.line2">
                                <td></td>
                                <td class="font-bold">Итого</td>
                                <td class="font-bold">{{report_new_1.res.line1}}</td>
                                <td class="font-bold">{{report_new_1.res.line2}}</td>
                                <td class="font-bold">{{report_new_1.res.line3 ? 'да' : 'нет' }}</td>
          
                              </tr>
                            </template>
                            </tbody>
                          </table>
                        </div>
                      </v-sheet>
                    </v-tab-item>
  
                    <!-- Окончание члентств -->
                    <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(2)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(2)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          

                                <!-- <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div> -->

                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search12"
                                    v-model="newclient_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                  </div>

                          </div>



                                  <!-- <v-select
                                              class="rounded-lg custom__select"
                                              v-model="lastManager"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать менеджера"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              return-object
                                              @change="setManager"
                                              style="height: 48px; max-width: 100%; width: 100%">
                                          </v-select>

                                  <div v-for="(line,index) of managerList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setManager(line)"> X </div>
                                  </div> -->

                                  <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать менеджера
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                      </div>


                                  </div>


                                
                                <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedNomenclature = null, nomenclatureModal = true"
                                    >
                                    Выбор номеклатуры
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of nomenclatureList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearNomenclature(line)"> X </div>
                                  </div>


                                </div>

                                <div class="item" style="margin-right: 10px; display:flex; align-items: center; margin-left:0px; width:25%; flex-direction: column;">

  
                                                      <v-select
                                                                class="rounded-lg custom__select"
                                                                v-model="lastStatus"
                                                                :items="statuses_ext"
                                                                item-value="id"
                                                                item-text="name"
                                                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                                                placeholder="Статус продления"
                                                                append-icon="mdi-chevron-down"
                                                                outlined
                                                                dense
                                                                return-object
                                                                @change="setStatus"
                                                                style="height: 48px; max-width: 100%; width: 100%">
                                                            </v-select>

                                                    <div v-for="(line,index) of statusList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                                        <div >{{ index+1 }}. {{line.name}}</div>
                                                        <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setStatus(line)"> X </div>
                                                    </div>
                                </div>


                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-2" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" colspan="13" style="">Структурная ед.</th>
                            <!-- <th colspan="2">Продажи</th>
                            <th colspan="2">Возвраты</th>
                            <th colspan="2" class="no-wrap">Продажи с учетом возвратов</th>
                            <th colspan="3">Оплачено</th> -->
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="13" >Номенклатура</th>
                            <!-- <th>Количество</th>
                            <th>Стоимость</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th class="font-bold">Количество</th>
                            <th class="font-bold">Стоимость</th>
                            <th>Оплата</th>
                            <th class="no-wrap">Возврат оплаты</th>
                            <th class="font-bold">Оплата с уч-м возвратов</th> -->
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="">
                                Клиент
                            </th>
                            <th colspan="" style="">
                                Телефон
                            </th>
                            <th colspan="" style="">
                                Тег
                            </th>
                            <th colspan="" style="">
                                Менеджер отдела продаж
                            </th>
                            <th colspan="" style="">
                                Членство
                            </th>
                            <th colspan="" style="">
                                Стоимость
                            </th>
                            <th colspan="" style="">
                                Активирован
                            </th>
                            <th colspan="" style="">
                                Действует до
                            </th>
                            <th colspan="" style="">
                                Членство продления
                            </th>
                            <th colspan="" style="">
                                Количество членств
                            </th>
                            <th colspan="" style="">
                                Количество клиентов
                            </th>
                            <th colspan="" style="">
                                Количество посещений
                            </th>
                            <th colspan="" style="">
                                Процент продленных
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <template >
                            <template v-for="(line,ind) of report_new_2.column1">
                              <tr class="parrent"
                              :key="'0-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id)"
                                      :key="'01-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="children.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children[0].column2.id) }"
                                            @click="openChildren(children[0].column2.id)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children[0].column2.name }}</td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ children[0].line10 }}</td>
                                    <td>{{ children[0].line11 }}</td>
                                    <td>{{ children[0].line12 }}</td>
                                    <td>{{ children[0].line13 }}</td>


                                  </tr>

                                  <template v-if="children.length > 0">
                                    <template v-for="(children2, index2) of children">
                                      <tr v-if="openParentLine.includes(children[0].column2.id) && index2 !== 0"
                                          :key="'001-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children[0].column2.id) }">

                                        <td>
                                  
                                        </td>

                         
                                        <td>

                                            <router-link
                                                v-if="children2.line1 && children2.line1.name"
                                                    :to="{ name: 'CardClientNew', params: {client_id: children2.line1.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('22')">{{ children2.line1.name }}</span>

                                            </router-link>
                                            <div v-else></div>
                                        

                                        </td>
                                        <td>{{ children2.line2 }}</td>
                                        <td>{{ children2.line3 }}</td>
                                        <td>{{ children2.line4.name ? children2.line4.name : ''}}</td>
                                        <td>

                                            <router-link
                                                v-if="children2.line5 && children2.line5.name"
                                                    :to="{ name: 'CardSubscribe', params: {client_id: children2.line1.id, product_id: children2.line5.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('22')">{{ children2.line5 ? children2.line5.name : '' }}</span>

                                            </router-link>
                                            <div v-else></div>
                                        
                                        </td>
                                        <td>{{ children2.line6 }}</td>
                                        <td>{{ children2.line7 }}</td>
                                        <td>{{ children2.line8 }}</td>
                                        <td>
                                            <router-link
                                                v-if="children2.line9 && children2.line9.name"
                                                    :to="{ name: 'CardSubscribe', params: {client_id: children2.line1.id, product_id: children2.line9.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('22')">{{ children2.line9 ? children2.line9.name : '' }}</span>

                                            </router-link>
                                            <div v-else></div>
                                        </td>
                                        <td>{{ children2.line10 }}</td>
                                        <td>{{ children2.line11 }}</td>
                                        <td>{{ children2.line12 }}</td>
                                        <td>{{ children2.line13 }}</td>
                                      </tr>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_2 && report_new_2.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line10}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line11}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line12}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line13}}</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>
                    
                <!-- члентства -->
                <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                   
                            <v-btn dark class="filter-button" @click="reportGenerate(3)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(3)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                            <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">


                                  <!-- <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div> -->

                                  <v-autocomplete
                                      colspan="1"
                                      :items="(listClient && listClient.client) ? listClient.client : []"
                                      item-value="client_id"
                                      item-text="name"
                                      placeholder="Поиск клиентов"
                                      hide-no-data
                                      :search-input.sync="search22"
                                      v-model="newclient_id2"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                      :no-filter=true
                                      class="rounded-lg"
                                      append-icon=""
                                      hide-details
                                      outlined
                                      dense
                                      background-color="white"
                                      style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                      required
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon>mdi-magnify</v-icon>
                                    </template>

                                    <template v-slot:item=" { item } ">
                                      <a @click="changeUsername(item,2)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                        {{ item.name }} тел.:{{ item.phone }}
                                      </a>
                                    </template>
                                  </v-autocomplete>

                                  <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                        <div >{{ index+1 }}. {{line.name}}</div>
                                        <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line,2)"> X </div>
                                    </div>

                            </div>

                              <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать менеджера
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                      </div>


                              </div>

                                  
                                  <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">

                                    <div style="height:48px;">
                                      <v-btn
                                          class="button__lighten"
                                          style="width:100%;"
                                          @click="chosedNomenclature = null, nomenclatureModal = true"
                                      >
                                      Выбор номеклатуры
                                      </v-btn>
                                    </div>

                                    <div v-for="(line,index) of nomenclatureList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                        <div >{{ index+1 }}. {{line.name}}</div>
                                        <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearNomenclature(line)"> X </div>
                                    </div>


                                  </div>
                                  
                                  <div class="item" style="margin-right: 10px; display:flex; align-items: center; margin-left:0px; width:25%;">
                                      <div v-if="filter.status" style="cursor: pointer; color:red; margin-right:10px;" @click="filter.status = null"> X </div>

                                              <v-select
                                                          class="rounded-lg custom__select"
                                                          v-model="filter.status"
                                                          :items="statuses"
                                                          item-value="id"
                                                          item-text="name"
                                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                                          placeholder="Выбрать статус"
                                                          append-icon="mdi-chevron-down"
                                                          outlined
                                                          dense
                                                          style="height: 48px;margin-top: 10px; width: 100%">
                                                      </v-select>
                                    </div>

                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-3" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" colspan="8" style="">Структурная ед. членства</th>
                            <th rowspan="4"> Количество членств</th>
                            <th rowspan="4"> Количество клиентов</th>
                            <th rowspan="4"> Количество посещений</th>
                            <th rowspan="4"> Количество доп. владельцев</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="8" >Статус</th>
                  
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="8" >Номенклатура членства</th>
                  
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="">
                                Клиент
                            </th>
                            <th colspan="" style="">
                                Телефон
                            </th>
                            <th colspan="" style="">
                                Менеджер
                            </th>
                            <th colspan="" style="">
                                Членство
                            </th>
                            <th colspan="" style="">
                                Стоимость
                            </th>
                            <th colspan="" style="">
                                Долг
                            </th>
                            <th colspan="" style="">
                                Активирован
                            </th>
                            <th colspan="" style="">
                                Действует до
                            </th>
                  
              
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_3 && report_new_3.column1">
                            <template v-for="(line,ind) of report_new_3.column1">
                              <tr class="parrent"
                              :key="'03-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id)"
                                      :key="'031-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="Object.keys(children.column3).length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children.res.column2) }"
                                            @click="openChildren(children.res.column2)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children.res.column2 }}</td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{  children.res.line10}}</td>
                                    <td>{{  children.res.line11}}</td>
                                    <td>{{  children.res.line12}}</td>
                                    <td>{{  children.res.line13}}</td>


                                  </tr>

                                  <template v-if="children.column3 && Object.keys(children.column3).length > 0">
                                    <template v-for="(children2, index2) of children.column3">
                                      <tr v-if="openParentLine.includes(children2[0].column2) && index2 !== 0"
                                          :key="'00031-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children2[0].column2) }">

                                          <td>
                                            <template v-if="children2.length > 0">
                                              <button
                                                  :class="{ 'open-hide': true, open: openParentLine.includes(children2[0].column3.id) }"
                                                  @click="openChildren(children2[0].column3.id)"></button>
                                            </template>
                                          </td>

                                          <td>{{ children2[0].column3.name }}</td>

                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{{children2[0].line10}}</td>
                                            <td>{{children2[0].line11}}</td>
                                            <td>{{children2[0].line12}}</td>
                                            <td>{{children2[0].line13}}</td>


                                            </tr>

                                            <template v-if="children2 && children2.length > 0">
                                            <template v-for="(children3, index3) of children2">
                                              <tr v-if="openParentLine.includes(children2[0].column3.id) && index3 !== 0"
                                                  :key="'00031-'+index3"
                                                  :class="{ children: true, open: openParentLine.includes(children2[0].column3.id) }">

                                                  <td></td>

                                                <td>

                                                      <router-link
                                                          v-if="children3.line1 && children3.line1.name"
                                                              :to="{ name: 'CardClientNew', params: {client_id: children3.line1.id}}"
                                                              class="d-flex"
                                                              style="align-items: center; text-decoration: none; color: #000"
                                                          >
                                                            <span @click="setReportParam('23')">{{ children3.line1.name }}</span>

                                                      </router-link>
                                                      <div v-else></div>
                                                  

                                                </td>

                                                <td>

                                                  <router-link
                                                      v-if="children3.line2 && children3.line2"
                                                          :to="{ name: 'CardClientNew', params: {client_id: children3.line1.id}}"
                                                          class="d-flex"
                                                          style="align-items: center; text-decoration: none; color: #000"
                                                      >
                                                        <span @click="setReportParam('23')">{{ children3.line2 }}</span>

                                                  </router-link>
                                                  <div v-else></div>


                                                  </td>

                                                <td>{{ children3.line3.name }}</td>
                                                <td>

                                            <router-link
                                                          v-if="children3.line4 && children3.line4.name"
                                                              :to="{ name: 'CardSubscribe', params: {client_id: children3.line1.id, product_id: children3.line4.id}}"
                                                              class="d-flex"
                                                              style="align-items: center; text-decoration: none; color: #000"
                                                          >
                                                            <span @click="setReportParam('23')">{{ children3.line4 ? children3.line4.name : '' }}</span>

                                                      </router-link>
                                                      <div v-else></div>
                                                  
                                                  </td>
                                        <td>{{ children3.line5 }}</td>
                                        <td>{{ children3.line6 }}</td>
                                        <td>{{ children3.line7 }}</td>
                                        <td>{{ children3.line8 }}</td>
                                        <td>{{ children3.line9 }}</td>
                                        <td>{{ children3.line10 }}</td>
                                        <td>{{ children3.line11 }}</td>
                                        <td>{{ children3.line12 }}</td>
                                      </tr>
                                    </template>
                                  </template>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_3 && report_new_3.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold">{{report_new_3.column1[Object.keys(report_new_3.column1)[0]].res.line10}}</td>
                              <td class="font-bold">{{report_new_3.column1[Object.keys(report_new_3.column1)[0]].res.line11}}</td>
                              <td class="font-bold">{{report_new_3.column1[Object.keys(report_new_3.column1)[0]].res.line12}}</td>
                              <td class="font-bold">{{report_new_3.column1[Object.keys(report_new_3.column1)[0]].res.line13}}</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>

                <!-- Продажи и оплаты по клиентам -->
                <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(4)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(4)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:16%;">

                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search13"
                                    v-model="newclient_id3"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item,3)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line,3)"> X </div>
                                  </div>

                          </div>

                                  <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:16%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать менеджера
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                      </div>


                              </div>
                             <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:16%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedSaleSpecialist = null, saleSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать продавца
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of saleSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearSaleSpecialist(line)"> X </div>
                                      </div>


                              </div>

                              <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:16%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedMakerSpecialist = null, makerSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать исполнителя
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of makerSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearMakerSpecialist(line)"> X </div>
                                      </div>


                              </div>


                                
                                <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:16%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedNomenclature = null, nomenclatureModal = true"
                                    >
                                    Выбор номеклатуры
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of nomenclatureList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearNomenclature(line)"> X </div>
                                  </div>


                                </div>
                                
                                <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:16%;">
  
                        
                                  <div style="width:100%;">
                                  
                                    <v-select class="rounded-lg custom__select" @change="setUit" v-model="lastUit"
                                              return-object
                                              :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                              placeholder="Подразделение" append-icon="mdi-chevron-down" outlined
                                              dense style="height: 48px;margin-top: 10px; width:100%;"
                                              >
                                    </v-select>
                                  </div>

                                  <div v-for="(line,index) of uitList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setUit(line)"> X </div>
                                  </div>

                                </div>

                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-4" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" style="width:50%;">Структурная ед.</th>
                            <th colspan="2">Продажи</th>
                            <th colspan="2">Возвраты</th>
                            <th colspan="2" class="no-wrap">Продажи с учетом возвратов</th>
                            <th colspan="3">Оплачено</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th>Номенклатура</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th class="font-bold">Количество</th>
                            <th class="font-bold">Стоимость</th>
                            <th>Оплата</th>
                            <th class="no-wrap">Возврат оплаты</th>
                            <th class="font-bold">Оплата с уч-м возвратов</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="display:flex; justify-content: space-around;">
                              <div>Клиент</div>
                              <div>Телефон</div>
                              <div>Менеджер</div>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <template >
                            <template v-for="(line,ind) of report_new_4.column1">
                              <tr class="parrent"
                              :key="'0-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td>{{ line.res.line1 ? line.res.line1.quantity : 0 }}</td>
                                
                                <td class="no-wrap">{{ line.res.line1 ? line.res.line1.sum : 0 }} ₽</td>
                                
                                <td>{{ line.res.line2 ? line.res.line2.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line2 ? line.res.line2.sum : 0 }} ₽</td>
                                <td>{{ line.res.line3 ? line.res.line3.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line3.sum }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.refund }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment_including_return }} ₽
                                </td>
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id)"
                                      :key="'01-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="children.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children[0].column2.id) }"
                                            @click="openChildren(children[0].column2.id)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children[0].column2.name }}</td>
                                    <td>{{ children[0].line1.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line1.sum }} ₽
                                    </td>
                                    <td>{{ children[0].line2.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line2.sum }}
                                      ₽
                                    </td>
                                    <td>{{
                                        children[0].line3.quantity
                                      }}
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line3.sum
                                      }} ₽
                                    </td>
                                    <td>{{ children[0].line4.payment }}</td>
                                    <td class="no-wrap">{{
                                        children[0].line4.return
                                      }} ₽
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line4.payment_including_return
                                      }} ₽
                                    </td>
                                  </tr>

                                  <template v-if="children.length > 0">
                                    <template v-for="(children2, index2) of children">
                                      <tr v-if="openParentLine.includes(children[0].column2.id) && index2 !== 0"
                                          :key="'001-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children[0].column2.id) }">

                                        <td>
                                  
                                        </td>

                                        <td>
                                          <div style="display:flex; justify-content: space-around;">

                                            <router-link
                                                v-if="children2.column3 && children2.column3.client && children2.column3 && children2.column3.client.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: children2.column3.client.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('24')">{{ children2.column3.client.name }}</span>
                                            </router-link>
                                            <div v-else></div>
                                                
                                            <div style="">{{ (children2.column3 && children2.column3.phone) ? children2.column3.phone : '' }}</div>
                                            <div>{{ (children2.column3 && children2.column3.manager) ? children2.column3.manager.name : '' }} </div>

                                          </div>
                                        </td>
                                        <td>{{ children2.line1.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line1.sum }} ₽
                                        </td>
                                        <td>{{ children2.line2.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line2.sum }}
                                          ₽
                                        </td>
                                        <td>{{
                                            children2.line3.quantity
                                          }}
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line3.sum
                                          }} ₽
                                        </td>
                                        <td>{{ children2.line4.payment }}</td>
                                        <td class="no-wrap">{{
                                            children2.line4.return
                                          }} ₽
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line4.payment_including_return
                                          }} ₽
                                        </td>
                                      </tr>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_4 && report_new_4.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line1.quantity}}</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line1.sum}} ₽</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line2.quantity}}</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line2.sum}} ₽</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line3.quantity}}</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line3.sum}} ₽</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line4.payment}} ₽</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line4.refund}} ₽</td>
                              <td class="font-bold">{{report_new_4.column1[Object.keys(report_new_4.column1)[0]].res.line4.payment_including_return}} ₽</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>


                <!-- Посещения по клиентам -->
                <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(5)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(5)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          

                                <!-- <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div> -->

                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search14"
                                    v-model="newclient_id4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item,4)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line,4)"> X </div>
                                  </div>

                          </div>

                     

                                  <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать менеджера
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                      </div>


                                  </div>


                                
                                <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedNomenclature = null, nomenclatureModal = true"
                                    >
                                    Выбор номеклатуры
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of nomenclatureList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearNomenclature(line)"> X </div>
                                  </div>


                                </div>


                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-5" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" colspan="6" style="">Структурная единица</th>
                            <th > Количество посещений</th>
             
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="6" >Номенклатура основания</th>
                  
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="6" >Клиент</th>
                  
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="">
                                Клиент
                            </th>
                            <th colspan="" style="">
                                Телефон
                            </th>
                            <th colspan="" style="">
                                Менеджер отдела продаж
                            </th>
                            <th colspan="" style="">
                                Посещение дата прихода
                            </th>
                            <th colspan="" style="">
                              Посещение дата ухода
                            </th>
                            <th colspan="" style="">
                                Тег
                            </th>
                  
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_5 && report_new_5.column1">
                            <template v-for="(line,ind) of report_new_5.column1">
                              <tr class="parrent"
                              :key="'03-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                    
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id) && children.column3 && children.res"
                                      :key="'031-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">
                                  
                                     <td>
                                      <template v-if="(Object.keys(children.column3).length > 0) && children.res">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children.res.column2.id) }"
                                            @click="openChildren(children.res.column2.id)"></button>
                                      </template>
                                    </td>

                                    <td>
                                      <div v-if="children.res" style="padding-left:20px;">{{ children.res.column2.name }}</div>
                                    </td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><div v-if="children.res">{{ children.res.line7 }}</div></td> 
                              

                                  </tr>

                                  <template v-if="children.column3 && Object.keys(children.column3).length > 0">
                                    <template v-for="(children2, index2) of children.column3">
                                      <tr v-if="openParentLine.includes(children2[0].column2.id) && index2 !== 0"
                                          :key="'00031-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children2[0].column2.id) }">

                                          <td>
                                            <template v-if="children2.length > 0">
                                              <button
                                                  :class="{ 'open-hide': true, open: openParentLine.includes(children2[0].column3.id) }"
                                                  @click="openChildren(children2[0].column3.id)"></button>
                                            </template>
                                          </td>

                                          <td>

                                    
                                            <router-link
                                                          v-if="children2[0].column3.id"
                                                              :to="{ name: 'CardClientNew', params: {client_id: children2[0].column3.id}}"
                                                              class="d-flex"
                                                              style="align-items: center; text-decoration: none; color: #000; padding-left:30px;"
                                                          >
                                                            <span @click="setReportParam('25')">{{ children2[0].column3.name }}</span>

                                                      </router-link>
                                                      <div v-else></div>
                                          </td>

                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{{children2[0].line7}}</td>


                                            </tr>

                                            <template v-if="children2 && children2.length > 0">
                                            <template v-for="(children3, index3) of children2">
                                              <tr v-if="openParentLine.includes(children2[0].column3.id) && index3 !== 0"
                                                  :key="'00031-'+index3"
                                                  :class="{ children: true, open: openParentLine.includes(children2[0].column3.id) }">

                                                  <td></td>
                                                  <td></td>
                                                  <td>{{ children3.line1 }}</td>



                                                <td>{{ children3.line2.name }}</td>
                              
                                        <td>{{ children3.line4 }}</td>
                                        <td>{{ children3.line5 }}</td>
                                        <td>{{ children3.line6 }}</td>
                                        <td>{{ children3.line7 }}</td>
                     
                                      </tr>
                                    </template>
                                  </template>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_5 && report_new_5.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold" colspan="5"></td>
                              <td class="font-bold">{{report_new_5.column1[Object.keys(report_new_5.column1)[0]].res.line7}}</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>


                <!-- Отчёт по звонкам -->
                <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">

                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(6)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled" 
                                @click="reportExport(6)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          

                                <!-- <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div> -->

                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search15"
                                    v-model="newclient_id5"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item,5)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line,5)"> X </div>
                                  </div>

                          </div>

                            <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                      <div style="height:48px;">
                                        <v-btn
                                            class="button__lighten"
                                            style="width:100%;"
                                            @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                        >
                                        Выбрать менеджера
                                        </v-btn>
                                      </div>

                                      <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                          <div >{{ index+1 }}. {{line.name}}</div>
                                          <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                      </div>


                              </div>

                                
                                <div class="item" style="margin-right: 10px; display:flex; align-items: center; margin-left:20px; width:25%;">
                                  <div v-if="filter.call_type" style="cursor: pointer; color:red; margin-right:10px;" @click="filter.call_type = null"> X </div>

                                          <v-select
                                                      class="rounded-lg custom__select"
                                                      v-model="filter.call_type"
                                                      :items="call_types"
                                                      item-value="id"
                                                      item-text="name"
                                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                                      placeholder="Тип звонка"
                                                      append-icon="mdi-chevron-down"
                                                      outlined
                                                      dense
                                                      style="height: 48px;margin-top: 10px;  width: 100%">
                                                  </v-select>
                                </div>


                        </div>
                       
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-6" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" colspan="8" style="">Менеджер</th>
                            <th rowspan="3">Количество звонков</th>
                            <th rowspan="3">Количество разговоров</th>
                            <th rowspan="3">Время</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="8" >Тип звонка</th>
      
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" >Клиент</th>
                            <th colspan="" >Телефон</th>
                            <th colspan="" >Дата</th>
                            <th colspan="" >Начало вызова</th>
                            <th colspan="" >Начало разговора</th>
                            <th colspan="" >Окончание звонка</th>
                            <th colspan="" >Длительность</th>
                            <th colspan="" >Запись</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template >
                            <template v-for="(line,ind) of report_new_6.column1">
                              <tr class="parrent"
                              v-if="line.column2 && line.res"
                              :key="'0-'+ind">
                                <td>
                                  <template v-if="line.column2 && line.res && Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td v-if="line.res">{{ line.res.column1.name }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td v-if="line.res">{{ line.res.line8 }}</td>
                                <td v-if="line.res">{{ line.res.line10 }}</td>
                                <td v-if="line.res">{{ line.res.line9 }}</td>
                              </tr>
                              <template v-if="line.column2 && Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="line.res && openParentLine.includes(line.res.column1.id)"
                                      :key="'01-'+index+line.res.column1.id"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="children.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(ind+'--'+children[0].column2) }"
                                            @click="openChildren(ind+'--'+children[0].column2)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children[0].column2 }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ children[0].line8 }}</td>
                                    <td>{{ children[0].line10 }}</td>
                                    <td>{{ children[0].line9 }}</td>
                                  </tr>

                                  <template v-if="children.length > 0">
                                    <template v-for="(children2, index2) of children">
                                      <tr v-if="openParentLine.includes(ind+'--'+children[0].column2) && index2 !== 0"
                                          :key="'001-'+index2+'001-'+line.res.column1.id"
                                          :class="{ children: true, open: openParentLine.includes(ind+'--'+children[0].column2) }">

                                        <td>
                                  
                                        </td>

                                        <td>

                                            <router-link
                                                v-if="children2.column3 && children2.column3.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: children2.column3.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('26')">{{ children2.column3.name }}</span>
                                            </router-link>
                                            <div v-else></div>
                                                
                                         
                                        </td>

                                        <td>{{ children2.line1 }}</td>
                                        <td>{{ children2.line2 }}</td>
                                        <td>{{ children2.line3 }}</td>
                                        <td>{{ children2.line4 }}</td>
                                        <td>{{ children2.line5 }}</td>
                                        <td>{{ children2.line6 }}</td>
                                        <td>
                                          <a v-if="children2.line7" :href="children2.line7" target="a_blank">
                                            Слушать
                                          </a>
                                          <div v-else></div>
                                        </td>
                                        <td>{{ children2.line8 }}</td>
                                        <td>{{ children2.line10 }}</td>
                                        <td>{{ children2.line9 }}</td>
                                      </tr>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_6 && report_new_6.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td colspan="7"></td>
                              <td class="font-bold">{{report_new_6.column1.res.line8}}</td>
                              <td class="font-bold">{{report_new_6.column1.res.line10}}</td>
                              <td class="font-bold">{{report_new_6.column1.res.line9}}</td>
                              <td></td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item> 


                <!-- Продажи/оплаты/промокоды -->
                <!-- <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <div style="width:300px; margin-right: 10px; display:flex; align-items: center; ">

                              <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div>

                              <v-autocomplete
                                  colspan="1"
                                  :items="(listClient && listClient.client) ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск клиентов"
                                  no-data-text="Результатов не найдено"
                                  :search-input.sync="search12"
                                  v-model="newclient_id"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                  :no-filter=true
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                                  style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                  required
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>

                                <template v-slot:item=" { item } ">
                                  <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                    {{ item.name }} тел.:{{ item.phone }}
                                  </a>
                                </template>
                              </v-autocomplete>
                            </div>

                            <v-btn dark class="filter-button" @click="reportGenerate(7)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                                   @click="printTable('table-1')">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-1" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" style="width:50%;">Структурная ед.</th>
                            <th colspan="2">Продажи</th>
                            <th colspan="2">Возвраты</th>
                            <th colspan="2" class="no-wrap">Продажи с учетом возвратов</th>
                            <th colspan="3">Оплачено</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th>Номенклатура</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th class="font-bold">Количество</th>
                            <th class="font-bold">Стоимость</th>
                            <th>Оплата</th>
                            <th class="no-wrap">Возврат оплаты</th>
                            <th class="font-bold">Оплата с уч-м возвратов</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="display:flex; justify-content: space-around;">
                              <div>Клиент</div>
                              <div>Телефон</div>
                              <div>Менеджер</div>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <template >
                            <template v-for="(line,ind) of report_new_2.column1">
                              <tr class="parrent"
                              :key="'0-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td>{{ line.res.line1 ? line.res.line1.quantity : 0 }}</td>
                                
                                <td class="no-wrap">{{ line.res.line1 ? line.res.line1.sum : 0 }} ₽</td>
                                
                                <td>{{ line.res.line2 ? line.res.line2.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line2 ? line.res.line2.sum : 0 }} ₽</td>
                                <td>{{ line.res.line3 ? line.res.line3.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line3.sum }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.refund }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment_including_return }} ₽
                                </td>
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id)"
                                      :key="'01-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="children.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children[0].column2.id) }"
                                            @click="openChildren(children[0].column2.id)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children[0].column2.name }}</td>
                                    <td>{{ children[0].line1.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line1.sum }} ₽
                                    </td>
                                    <td>{{ children[0].line2.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line2.sum }}
                                      ₽
                                    </td>
                                    <td>{{
                                        children[0].line3.quantity
                                      }}
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line3.sum
                                      }} ₽
                                    </td>
                                    <td>{{ children[0].line4.payment }}</td>
                                    <td class="no-wrap">{{
                                        children[0].line4.return
                                      }} ₽
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line4.payment_including_return
                                      }} ₽
                                    </td>
                                  </tr>

                                  <template v-if="children.length > 0">
                                    <template v-for="(children2, index2) of children">
                                      <tr v-if="openParentLine.includes(children[0].column2.id) && index2 !== 0"
                                          :key="'001-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children[0].column2.id) }">

                                        <td>
                                  
                                        </td>

                                        <td>
                                          <div style="display:flex; justify-content: space-around;">

                                            <router-link
                                                v-if="children2.column3 && children2.column3.client && children2.column3 && children2.column3.client.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: children2.column3.client.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('21')">{{ children2.column3.client.name }}</span>
                                            </router-link>
                                            <div v-else></div>
                                                
                                            <div style="">{{ (children2.column3 && children2.column3.phone) ? children2.column3.phone : '' }}</div>
                                            <div>{{ (children2.column3 && children2.column3.manager) ? children2.column3.manager.name : '' }} </div>

                                          </div>
                                        </td>
                                        <td>{{ children2.line1.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line1.sum }} ₽
                                        </td>
                                        <td>{{ children2.line2.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line2.sum }}
                                          ₽
                                        </td>
                                        <td>{{
                                            children2.line3.quantity
                                          }}
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line3.sum
                                          }} ₽
                                        </td>
                                        <td>{{ children2.line4.payment }}</td>
                                        <td class="no-wrap">{{
                                            children2.line4.return
                                          }} ₽
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line4.payment_including_return
                                          }} ₽
                                        </td>
                                      </tr>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_2 && report_new_2.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line1.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line1.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line2.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line2.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line3.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line3.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.payment}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.refund}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.payment_including_return}} ₽</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item> -->



                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-container>
          </v-row>


          <v-row>
            <v-dialog
                  v-model="nomenclatureModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="nomenclatureModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>Номенклатура</h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="nomenclatureModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск номенклатуры"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearch"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.nomenclature_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.nomenclature_id = null"> X </div>
                      <div v-if="filter.nomenclature_id">{{filter.nomenclature_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="listAllServicesDef && listAllServicesDef.sales"
                    :items="listAllServicesDef.sales"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTree"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToNomenclatureParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToNomenclature(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveNomenclature"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>


          <v-row justify="center" >
              <v-dialog
                  v-model="report1Detail"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="report1Detail">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                    </div>
                    <v-btn icon @click="report1Detail = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
                        
                        <div class="scroll-table">
                        <table id="table-211" cellpadding="1">
                          <thead>
                          <tr>
                            <th class="font-bold">Регистратор</th>
                            <th class="font-bold">Сумма план</th>
                            <th class="font-bold">Сумма факт</th>
                            <th class="font-bold">План выполнен</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_1_detail && report_new_1_detail.data && report_new_1_detail.data.length > 0">
                            <template v-for="(line,index) of report_new_1_detail.data">
                              <tr class="" :key="index" v-if="!line.result">
                                <td class="no-wrap td-check">

                                    <router-link
                                                v-if="line.column1 && line.column1.id"
                                                   :to="{name: 'Sale', params: {client: client_detail, buy_id: line.column1.id, type: 'info'}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('21')">{{ line.column1.name }}</span>

                                            </router-link>
                                            <div v-else>{{ line.column1.name }}</div>
                                            
                                </td>

                                <td>    
                                    {{ line.line1 }}
                                </td>
                                <td>    
                                    {{ line.line2 }}
                                </td>
                                <td>    
                                    <span v-if="line.line3">да</span>
                                    <span v-else>нет</span>
                                </td>

                              </tr>
                            
                            </template>
                            <tr class="parrent" v-if="report_new_1_detail && report_new_1_detail.data.length > 0">
                                <td>Итого:</td>
                                <td>{{ report_new_1_detail.data[report_new_1_detail.data.length-1].line1 }}</td>
                                <td>{{ report_new_1_detail.data[report_new_1_detail.data.length-1].line2 }}</td>
                                <td></td>
                            </tr>

                          </template>
                          </tbody>
                        </table>
                      </div>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
                  v-model="groupSpecialistModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="groupSpecialistModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>
                        Менеджеры
                      </h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="groupSpecialistModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearchGroup"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.group_specialist_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.group_specialist_id = null"> X </div>
                      <div v-if="filter.group_specialist_id">{{filter.group_specialist_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="specialistGroup && specialistGroup.specialistGroup"
                    :items="specialistGroup.specialistGroup"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTreeGroup"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToGroupSpecialistParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToGroupSpecialist(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <!-- <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span> -->
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveGroupSpecialist"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
                  v-model="saleSpecialistModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="saleSpecialistModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>
                        Продавцы
                      </h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="saleSpecialistModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearchSale"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.sale_specialist_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.sale_specialist_id = null"> X </div>
                      <div v-if="filter.sale_specialist_id">{{filter.sale_specialist_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="specialistGroup && specialistGroup.specialistGroup"
                    :items="specialistGroup.specialistGroup"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTreeSale"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToSaleSpecialistParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToSaleSpecialist(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <!-- <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span> -->
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveSaleSpecialist"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
                  v-model="makerSpecialistModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="makerSpecialistModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>
                        Исполнители
                      </h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="makerSpecialistModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearchMaker"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.maker_specialist_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.maker_specialist_id = null"> X </div>
                      <div v-if="filter.maker_specialist_id">{{filter.maker_specialist_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="specialistGroup && specialistGroup.specialistGroup"
                    :items="specialistGroup.specialistGroup"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTreeMaker"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToMakerSpecialistParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToMakerSpecialist(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <!-- <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span> -->
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveMakerSpecialist"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>



        </v-container>
      </v-main>
      <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
    </v-app>
  </template>
  <script>
  import {VueDatePicker} from '@mathieustan/vue-datepicker';
  import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
  import {reportActionTypes} from '@/store/modules/report';
  import Header from '@/components/Header.vue';
  import Menu from '@/components/Menu.vue';
  import {getItem, setItem} from "@/helpers/persistanceStorage";
  import {cashboxActionTypes} from "@/store/modules/cashbox";
  import {clientActionTypes} from '@/store/modules/client';
  import {lessonActionTypes} from "@/store/modules/lesson";
  import {departmentActionTypes} from '@/store/modules/department';
  import {salesActionTypes} from "@/store/modules/sale";
  import {mapState} from "vuex";
  //import excel from 'vue-excel-export';
  
  export default {
    name: 'ReportsSalesDepartment',
    components: {
      VueDatePicker,
      Header,
      Menu
    },
    data() {
      return {
        date: {
          start: new Date(),
          end: new Date(),
        },
        months: [
          'январь',
          'февраль',
          'март',
          'апрель',
          'май',
          'июнь',
          'июль',
          'август',
          'сентябрь',
          'октябрь',
          'ноябрь',
          'декабрь'
        ],
        headers: [],
        reportType: [
          {id: 0, name: 'Продажи-планфакт'},
          {id: 1, name: 'Окончание членств'},
          {id: 2, name: 'Членства'},
          {id: 3, name: 'Продажи и оплаты по клиентам'},
          {id: 4, name: 'Посещения по клиентам'},
          {id: 5, name: 'Отчёт по звонкам'}
          // {id: 6, name: 'Продажи/оплаты/промокоды'}
        ],
        reportTab: 0,
        itemsStrucuUit: [
          {title: 'Все организации', value: null},
          {title: 'ИП Сорокин Н.С.', value: "c1094ab2-dcc2-11ec-a062-60e32700ce56"},
          {title: 'ООО \"КлеверСпорт\"', value: "5738e017-5875-11ea-80e1-9c5c8e747603"}
        ],
        itemsClient: [
          {title: 'Ковалев А.Ю.', value: '1'},
          {title: 'Сидорова В.П.', value: '2'},
          {title: 'Самойлов К.И.', value: '3'},
        ],
        itemsDivision: [
          {title: 'Подразделение 1', value: '1'},
          {title: 'Подразделение 2', value: '2'},
          {title: 'Подразделение 3', value: '3'},
        ],
        filter: {
          date: new Date(),
          client: null,
          uit: null,
          division: null,
          nomenclature_id:null,
          manager_id:null,
          call_type:null,
          status:"Активен",
          status_ext:"Не продлено"
        },
        buttonDisabled: false,
        reportData: [],
        reportData2: [],
        reportData3: [],
        report: [],
        openParentLine: [],
        listCashbox: JSON.parse(getItem('list-cashbox')) ?? [],
        select_cashbox: null,
        select_cashbox_id: null,
        report_new_1:[],
        report_new_2:[],
        report_new_3:[],
        report_new_4:[],
        report_new_5:[],
        report_new_6:[],
        report_new_7:[],
        isLoadingReport:false,
        newclient_id:null,
        newclient_id2:null,
        newclient_id3:null,
        newclient_id4:null,
        newclient_id5:null,
        search: '',
        search12: '',
        search13: '',
        search14: '',
        search15: '',
        search16: '',
        search17: '',
        search22:'',
        rooms_list:[],
        room_id:null,
        departmentListDef:[],
        report_new_1_detail:[],
        report1Detail:false,
        client_detail:null,
        manager_id:null,
        call_type:null,
        searchService: null,
        caseSensitive:false,
        statuses_ext:[
          {
            name:"Продлено",
            id:"Продлено"
          },
          {
            name:"Не продлено",
            id:"НеПродлено"
          },
          {
            name:"Не требует продления",
            id:"НеТребуетПродления"
          },
          {
            name:"Отказ от продления",
            id:"ОтказОтПродления"
          }
        ],
        statuses:[
          {
            id:"Продан",
            name:"Продан"
          },
          {
            id:"Активен",
            name:"Активен"
          },
          {
            id:"Заблокирован",
            name:"Заблокирован"
          },
          {
            id:"Заморожен",
            name:"Заморожен"
          },
          {
            id:"Закрыт",
            name:"Закрыт"
          }
        ],
        call_types:[
        {
            id:"Входящий",
            name:"Входящий"
          },
          {
            id:"Исходящий",
            name:"Исходящий"
          },
          {
            id:"Пропущенный",
            name:"Пропущенный"
          }
        ],
        listAllServicesDef:null,
        uitList:[],
        lastUit:null,
        clientList:[],
        nomenclatureModal:false,
        nomenclatureList:[],
        managerList:[],
        statusList:[],
        lastManager:null,
        lastStatus:null,
        json_fields: {
            'Complete name': 'name',
            'City': 'city',
            'Telephone': 'phone.mobile',
            'Telephone 2' : {
                field: 'phone.landline',
                callback: (value) => {
                    return `Landline Phone - ${value}`;
                }
            },
        },
        json_data: [
            {
                'name': 'Tony Peña',
                'city': 'New York',
                'country': 'United States',
                'birthdate': '1978-03-15',
                'phone': {
                    'mobile': '1-541-754-3010',
                    'landline': '(541) 754-3010'
                }
            },
            {
                'name': 'Thessaloniki',
                'city': 'Athens',
                'country': 'Greece',
                'birthdate': '1987-11-23',
                'phone': {
                    'mobile': '+1 855 275 5071',
                    'landline': '(2741) 2621-244'
                }
            }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        groupSpecialistModal:false,
        groupSpecialistList:[],
        report_result:[],
        saleSpecialistModal:false,
        saleSpecialistList:[],
        makerSpecialistModal:false,
        makerSpecialistList:[],
        

      }
    },
    computed: {
      ...mapState({
        listClient: state => state.client.listClient,
        departmentList: state => state.department.departmentList,
        specialist: state => state.lesson.specialist,
        specialistGroup: state => state.lesson.specialistGroup
      }),
      searchPackages() {
        let res = this.caseSensitive
          ? sayMyNane(item, search, textKey)
          : undefined

          function sayMyNane(item, search, textKey){
            (item[textKey2].indexOf(search) > -1)
          }

        return res

      }
    },
    methods: {
         handleSearchMaker(input) {
  
          if (input && input.length >= 2) {
            this.$refs.myTreeMaker.updateAll(true)
          } else {
            this.$refs.myTreeMaker.updateAll(false)
          }
        },
        handleSearchSale(input) {
  
          if (input && input.length >= 2) {
            this.$refs.myTreeSale.updateAll(true)
          } else {
            this.$refs.myTreeSale.updateAll(false)
          }
        },
        handleSearchGroup(input) {
       
          if (input && input.length >= 2) {
            this.$refs.myTreeGroup.updateAll(true)
          } else {
            this.$refs.myTreeGroup.updateAll(false)
          }
        },



        saveMakerSpecialist(){

          let item = this.chosedMakerSpecialist

          if (this.makerSpecialistList.findIndex(n => n.id === item.id) !== -1) {
            //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
          } else {
            this.makerSpecialistList.push(item)
          }

          this.makerSpecialistModal = false
        },

        clearMakerSpecialist(item){
          if (this.makerSpecialistList.findIndex(n => n.id === item.id) !== -1) {
            this.makerSpecialistList.splice(this.makerSpecialistList.findIndex(n => n.id === item.id),1);
          } else {
          }
        },
        addToMakerSpecialistParent(itemar){
  
        if(itemar.length === 0) {
          return;
        }

        this.chosedMakerSpecialist = itemar[0]

        },  

        addToMakerSpecialist(item){

          this.chosedMakerSpecialist = item
  
        },  


      saveSaleSpecialist(){

          let item = this.chosedSaleSpecialist

          if (this.saleSpecialistList.findIndex(n => n.id === item.id) !== -1) {
            //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
          } else {
            this.saleSpecialistList.push(item)
          }

          this.saleSpecialistModal = false
        },

        clearSaleSpecialist(item){
          if (this.saleSpecialistList.findIndex(n => n.id === item.id) !== -1) {
            this.saleSpecialistList.splice(this.saleSpecialistList.findIndex(n => n.id === item.id),1);
          } else {
          }
        },
        addToSaleSpecialistParent(itemar){
  
        if(itemar.length === 0) {
          return;
        }

        this.chosedSaleSpecialist = itemar[0]

        },  

        addToSaleSpecialist(item){
          //console.log('child')
          //console.log(item)

          this.chosedGroupSpecialist = item

  
        },  
       saveGroupSpecialist(){

        let item = this.chosedGroupSpecialist

        if (this.groupSpecialistList.findIndex(n => n.id === item.id) !== -1) {
          //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
          this.groupSpecialistList.push(item)
        }

        this.groupSpecialistModal = false
        },
        clearGroupSpecialist(item){
        if (this.groupSpecialistList.findIndex(n => n.id === item.id) !== -1) {
          this.groupSpecialistList.splice(this.groupSpecialistList.findIndex(n => n.id === item.id),1);
        } else {
        }
        },
        addToGroupSpecialistParent(itemar){
        //console.log('parent2')
        //console.log(itemar)
        if(itemar.length === 0) {
          return;
        }

        this.chosedGroupSpecialist = itemar[0]

        // let item = itemar[0]
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
        },  
        addToGroupSpecialist(item){
        //console.log('child')
        //console.log(item)

        this.chosedGroupSpecialist = item

        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
        },  

      setManager(item){
        //console.log(item)
        if (this.managerList.findIndex(n => n.id === item.id) !== -1) {
          this.managerList.splice(this.managerList.findIndex(n => n.id === item.id),1);
        } else {
          this.managerList.push(item)
        }

        if(this.managerList.length === 0){
          this.lastManager = null
        }

      },
      setStatus(item){
        if (this.statusList.findIndex(n => n.id === item.id) !== -1) {
          this.statusList.splice(this.statusList.findIndex(n => n.id === item.id),1);
        } else {
          this.statusList.push(item)
        }

        if(this.statusList.length === 0){
          this.lastStatus = null
        }

      },
      setUit(item){
        //console.log(item)
        if (this.uitList.findIndex(n => n.id === item.id) !== -1) {
          this.uitList.splice(this.uitList.findIndex(n => n.id === item.id),1);
        } else {
          this.uitList.push(item)
        }

        if(this.uitList.length === 0){
          this.lastUit = null
        }

      },
      saveNomenclature(){

        let item = this.chosedNomenclature

        if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
          //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
          this.nomenclatureList.push(item)
        }

        this.nomenclatureModal = false
      },
      clearNomenclature(item){
        if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
          this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
        }
      },
      addToNomenclatureParent(itemar){
        //console.log('parent')
        //console.log(itemar)
        if(itemar.length === 0) {
          return;
        }

        this.chosedNomenclature = itemar[0]

        // let item = itemar[0]
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
      },  
      addToNomenclature(item){
        //console.log('child')
        //console.log(item)

        this.chosedNomenclature = item
   
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
      },  
      handleSearch(input) {
     
        if (input && input.length >= 2) {
          this.$refs.myTree.updateAll(true)
        } else {
          this.$refs.myTree.updateAll(false)
        }

      },
        getReport1Detail(product_id, employee_id, employee_name){

            this.isLoadingReport = true

            this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                client_id:this.newclient_id,
                department_id:product_id,
                employee_id:employee_id,
                detail:true,
                type:6
            })
            .then((response) => {

                if(response && response.success){

                    this.client_detail = {id:employee_id,name:employee_name}

                    this.report_new_1_detail = response.data
                    this.isLoadingReport = false

                    this.report1Detail = true
                } else {
                    alert('Ошибка формирования детализации отчёта!')
                    this.isLoadingReport = false
                }

                this.isLoadingReport = false

            })

        },
      setReportParam(param){
  
        if(this.newclient_id) {
          setItem('report2_newclient_id',this.newclient_id);
  
        }

      

            setItem('report2_nomenclatureList',JSON.stringify(this.nomenclatureList));
            setItem('report2_managerList',JSON.stringify(this.managerList));
            setItem('report2_clientList',JSON.stringify(this.clientList));
            setItem('report2_uitList',JSON.stringify(this.uitList));


  
        if(param === '21') {
          //console.log('set PARAMS')
          setItem('report_21',JSON.stringify(this.report_new_1));
          setItem('report_23',null);
          setItem('report_24',null);
          setItem('report_25',null);
          setItem('report_26',null);
          setItem('report_27',null);
  
          setItem('report2_start',this.filter.date.start);
          setItem('report2_end',this.filter.date.end);

            setItem('report2_report1Detail',true);
            setItem('report2_report1DetailData',JSON.stringify(this.report_new_1_detail));
            
          
        }
  
        if(param === '22') {
          //console.log('set PARAMS')
          setItem('report_22',JSON.stringify(this.report_new_2));
          setItem('report_23',null);
          setItem('report_24',null);
          setItem('report_25',null);
          setItem('report_26',null);
          setItem('report_21',null);
  
          setItem('report2_start',this.filter.date.start);
          setItem('report2_end',this.filter.date.end);
          
        }
  
        if(param === '23') {
          setItem('report_23',JSON.stringify(this.report_new_3));
          setItem('report_22',null);
          setItem('report_24',null);
          setItem('report_25',null);
          setItem('report_26',null);
          setItem('report_21',null);
        }
  
        if(param === '24') {
          setItem('report_24',JSON.stringify(this.report_new_4));
          setItem('report_22',null);
          setItem('report_23',null);
          setItem('report_25',null);
          setItem('report_26',null);
          setItem('report_21',null);
  
          setItem('report2_start',this.filter.date.start);
          setItem('report2_end',this.filter.date.end);
        }
  
        if(param === '25') {
          setItem('report_25',JSON.stringify(this.report_new_5));
          setItem('report_22',null);
        setItem('report_23',null);
        setItem('report_24',null);
        setItem('report_26',null);
        setItem('report_21',null);
        }
  
        if(param === '26') {
          setItem('report_26',JSON.stringify(this.report_new_6));
          setItem('report_22',null);
        setItem('report_23',null);
        setItem('report_24',null);
        setItem('report_25',null);
        setItem('report_21',null);
        }
  
        if(param === '17') {
          setItem('report_27',JSON.stringify(this.report_new_7));
          setItem('report_22',null);
        setItem('report_23',null);
        setItem('report_24',null);
        setItem('report_25',null);
        setItem('report_26',null);
        }
  
        
      },
      changeUsername(item) {
        //console.log(item)
        
        if (this.clientList.findIndex(n => n.client_id === item.client_id) !== -1) {
          this.clientList.splice(this.clientList.findIndex(n => n.client_id === item.client_id),1);
        } else {
          this.clientList.push(item)
        }

        if(this.clientList.length === 0){
          this.newclient_id = null
        }

        this.newclient_id = null
        this.newclient_id2 = null
        this.newclient_id3 = null
        this.newclient_id4 = null
        this.newclient_id5 = null


        this.search = null
        this.search12 = null
        this.search13 = null
        this.search14 = null
        this.search15 = null
        this.search16 = null
        this.search17 = null

        var elem = this.$refs.myBtn
        elem.click()

        //this.newclient_id = client

      },
      typeToDate(date) {
        this.$set(this.filter, 'date', new Date(date))
      },
      openChildren(id) {
        ////console.log(id)
        if (this.openParentLine.includes(id)) {
          ////console.log(id)
          this.$delete(this.openParentLine, this.openParentLine.indexOf(id))
        } else {
          ////console.log(id)
          this.$set(this, 'openParentLine', [...this.openParentLine, id])
        }
      },
      reportExport(type) {
  
  this.isLoadingReport = true

  if(type === 1){
      setItem('report_21',null);


      let uitListRes = []
      if(this.uitList.length > 0){
        for(let i = 0; i < this.uitList.length; i++){
          uitListRes.push(this.uitList[i].id)
        }
      }
      let managerListRes = []
      if(this.managerList.length > 0){
        for(let i = 0; i < this.managerList.length; i++){
          managerListRes.push(this.managerList[i].id)
        }
      }

      this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          department_id:(uitListRes.length > 0) ? uitListRes : [],
          manager_id:(managerListRes.length > 0) ? managerListRes : [],
          type:6,
          export:true,
          uitList:this.uitList,
          managerList:this.managerList
      })
      .then((response) => {
        if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
      })

  } else if(type === 2) {

    setItem('report_22',null);


    let clientListRes = []
    
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let statusListRes = []
            if(this.statusList.length > 0){
              for(let i = 0; i < this.statusList.length; i++){
                statusListRes.push(this.statusList[i].id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }

            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }
  

    this.$store.dispatch(reportActionTypes.revenueDivision, {
      date_start: this.filter.date.start,
      date_end: this.filter.date.end,
      client_id:(clientListRes.length > 0) ? clientListRes : [],
            nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
            manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
            status:(statusListRes.length > 0) ? statusListRes : [],
      type:22,
      export:true,
      managerList:this.managerList,
      nomenclatureList:this.nomenclatureList,
      clientList:this.clientList
    })
    .then((response) => {
      if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
    })

  } else if(type === 3) {

    setItem('report_23',null);

    let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }


    this.$store.dispatch(reportActionTypes.revenueDivision, {
      date_start: this.filter.date.start,
      date_end: this.filter.date.end,
      client_id:(clientListRes.length > 0) ? clientListRes : [],
      nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
      manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
      status:this.filter.status,
      type:33,
      export:true,
      managerList:this.managerList,
      nomenclatureList:this.nomenclatureList,
      clientList:this.clientList
    })
    .then((response) => {

      if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
    })

   } else if(type === 4) {

    setItem('report_24',null);


      let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let saleSpecialistListRes = []
            if(this.saleSpecialistList.length > 0){
              for(let i = 0; i < this.saleSpecialistList.length; i++){
                saleSpecialistListRes.push(this.saleSpecialistList[i].id)
              }
            }
            let makerListRes = []
            if(this.makerSpecialistList.length > 0){
              for(let i = 0; i < this.makerSpecialistList.length; i++){
                makerListRes.push(this.makerSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }
            let uitListRes = []
            if(this.uitList.length > 0){
              for(let i = 0; i < this.uitList.length; i++){
                uitListRes.push(this.uitList[i].id)
              }
            }

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:(clientListRes.length > 0) ? clientListRes : [],
                nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
                manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
                employee_id:(saleSpecialistListRes.length > 0) ? saleSpecialistListRes : [],
                maker_id:(makerListRes.length > 0) ? makerListRes : [],
                department_id:(uitListRes.length > 0) ? uitListRes : [],
          type:44,
          export:true,
          managerList:this.managerList,
          nomenclatureList:this.nomenclatureList,
          clientList:this.clientList,
          uitList:this.uitList
        })
        .then((response) => {
          if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
        })
        
    } else if(type === 5) {

      setItem('report_25',null);
           let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }

      this.$store.dispatch(reportActionTypes.revenueDivision, {
        date_start: this.filter.date.start,
        date_end: this.filter.date.end,
        client_id:(clientListRes.length > 0) ? clientListRes : [],
          nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
          manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
        type:55,
        export:true,
        nomenclatureList:this.nomenclatureList,
        managerList:this.managerList,
        clientList:this.clientList
      })
      .then((response) => {
        //this.headers = response.headers
        //this.report = response.revenue
        if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
      })
    } else if(type === 6) {


      setItem('report_26',null);


        let clientListRes = []
              if(this.clientList.length > 0){
                for(let i = 0; i < this.clientList.length; i++){
                  clientListRes.push(this.clientList[i].client_id)
                }
              }
              let groupSpecialistListRes = []
              if(this.groupSpecialistList.length > 0){
                for(let i = 0; i < this.groupSpecialistList.length; i++){
                  groupSpecialistListRes.push(this.groupSpecialistList[i].id)
                }
              }
        

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:(clientListRes.length > 0) ? clientListRes : [],
          manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
          call_type:this.filter.call_type,
          type:66,
          export:true,
          clientList:this.clientList,
          managerList:this.managerList,
          export:true
        })
        .then((response) => {
          //this.headers = response.headers
          //this.report = response.revenue
          if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
        })
      } else if(type === 7) {

        setItem('report_27',null);

          this.report_new_7 = []

          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:this.newclient_id,
            type:7,
            export:true
          })
          .then((response) => {

            if(response && response.success){
              this.report_new_7 = response.data
              this.isLoadingReport = false
            } else {
                alert('Данных не найдено!')
                this.isLoadingReport = false
              }
          })

  } else {
    this.$store.dispatch(reportActionTypes.revenueDivision, {
      date_start: this.date.start,
      date_end: this.date.end,
      type:11
    })
    .then((response) => {
      if(response && response.success){
        this.headers = response.headers
        this.report = response.revenue
        this.isLoadingReport = false
      } else {
        alert('Данных не найдено!')
        this.isLoadingReport = false
      }

    })
  }
},
      reportGenerate(type) {
  
        this.isLoadingReport = true
  
        if(type === 1){
            setItem('report_21',null);
  
            this.report_new_1 = []

            let uitListRes = []
            if(this.uitList.length > 0){
              for(let i = 0; i < this.uitList.length; i++){
                uitListRes.push(this.uitList[i].id)
              }
            }
            let managerListRes = []
            if(this.managerList.length > 0){
              for(let i = 0; i < this.managerList.length; i++){
                managerListRes.push(this.managerList[i].id)
              }
            }

            this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                department_id:(uitListRes.length > 0) ? uitListRes : [],
                manager_id:(managerListRes.length > 0) ? managerListRes : [],
                type:6
            })
            .then((response) => {
                //this.headers = response.headers
                //this.report = response.revenue
                if(response && response.success){
                this.report_new_1 = response.data
                this.isLoadingReport = false
                } else {
                    alert('Данных не найдено!')
                    this.isLoadingReport = false
                }
            })
  
        } else if(type === 2) {
  
          setItem('report_22',null);
  
          this.report_new_2 = []

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let statusListRes = []
            if(this.statusList.length > 0){
              for(let i = 0; i < this.statusList.length; i++){
                statusListRes.push(this.statusList[i].id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }

            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }
  
          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
            manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
            status:(statusListRes.length > 0) ? statusListRes : [],
            type:22
          })
          .then((response) => {
            //this.headers = response.headers
            //this.report = response.revenue
            if(response && response.success && response.success === true){
              this.report_new_2 = response.data
              this.isLoadingReport = false
  
            } else {
                alert('Данных не найдено!')
                this.isLoadingReport = false
              }
          })
  
        } else if(type === 3) {
  
          setItem('report_23',null);
  
          this.report_new_3 = []

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }

  
          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date,
            date_end: this.filter.date,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
            manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
            status:this.filter.status,
            type:33
          })
          .then((response) => {

            if(response && response.success){
              this.report_new_3 = response.data
              this.isLoadingReport = false
            } else {
                alert('Данных не найдено!')
                this.isLoadingReport = false
              }
          })
  
         } else if(type === 4) {
  
          setItem('report_24',null);
  
              this.report_new_4 = []

              
          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let saleSpecialistListRes = []
            if(this.saleSpecialistList.length > 0){
              for(let i = 0; i < this.saleSpecialistList.length; i++){
                saleSpecialistListRes.push(this.saleSpecialistList[i].id)
              }
            }
            let makerListRes = []
            if(this.makerSpecialistList.length > 0){
              for(let i = 0; i < this.makerSpecialistList.length; i++){
                makerListRes.push(this.makerSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }
            let uitListRes = []
            if(this.uitList.length > 0){
              for(let i = 0; i < this.uitList.length; i++){
                uitListRes.push(this.uitList[i].id)
              }
            }

              this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                client_id:(clientListRes.length > 0) ? clientListRes : [],
                nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
                manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
                employee_id:(saleSpecialistListRes.length > 0) ? saleSpecialistListRes : [],
                maker_id:(makerListRes.length > 0) ? makerListRes : [],
                department_id:(uitListRes.length > 0) ? uitListRes : [],
                type:44
              })
              .then((response) => {
                //this.headers = response.headers
                //this.report = response.revenue
                if(response && response.success && response.success === true){
                  this.report_new_4 = response.data
                  this.isLoadingReport = false

                } else {
                    alert('Данных не найдено!')
                    this.isLoadingReport = false
                  }
              })
              
          } else if(type === 5) {
  
            setItem('report_25',null);
  
            this.report_new_5 = []

            let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }
            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }
  
            this.$store.dispatch(reportActionTypes.revenueDivision, {
              date_start: this.filter.date.start,
              date_end: this.filter.date.end,
              client_id:(clientListRes.length > 0) ? clientListRes : [],
              nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
              manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
              type:55
            })
            .then((response) => {
              //this.headers = response.headers
              //this.report = response.revenue
              if(response && response.success){
                this.report_new_5 = response.data
                this.isLoadingReport = false
              } else {
                  alert('Данных не найдено!')
                  this.isLoadingReport = false
                }
            })
          } else if(type === 6) {
  
  
            setItem('report_26',null);
  
              this.report_new_6 = []

              let clientListRes = []
              if(this.clientList.length > 0){
                for(let i = 0; i < this.clientList.length; i++){
                  clientListRes.push(this.clientList[i].client_id)
                }
              }
              let groupSpecialistListRes = []
              if(this.groupSpecialistList.length > 0){
                for(let i = 0; i < this.groupSpecialistList.length; i++){
                  groupSpecialistListRes.push(this.groupSpecialistList[i].id)
                }
              }
        
  
              this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                client_id:(clientListRes.length > 0) ? clientListRes : [],
                manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
                call_type:this.filter.call_type,
                type:66
      
              })
              .then((response) => {
                //this.headers = response.headers
                //this.report = response.revenue
                if(response && response.success){
                  this.report_new_6 = response.data
                  this.isLoadingReport = false
                } else {
                    alert('Данных не найдено!')
                    this.isLoadingReport = false
                  }
              })
            } else if(type === 7) {
  
              setItem('report_27',null);
  
                this.report_new_7 = []
  
                this.$store.dispatch(reportActionTypes.revenueDivision, {
                  date_start: this.filter.date.start,
                  date_end: this.filter.date.end,
                  client_id:this.newclient_id,
                  type:7
                })
                .then((response) => {
  
                  if(response && response.success){
                    this.report_new_7 = response.data
                    this.isLoadingReport = false
                  } else {
                      alert('Данных не найдено!')
                      this.isLoadingReport = false
                    }
                })
  
        } else {
          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.date.start,
            date_end: this.date.end,
            type:11
          })
          .then((response) => {
            if(response && response.success){
              this.headers = response.headers
              this.report = response.revenue
              this.isLoadingReport = false
            } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
            }
      
          })
        }
      },
      printTable(tableID) {
        const style = `<style>@media print {
          td:first-child,
          th:first-child {
              display: none;
          }
  }</style>`
        window.frames["print_frame"].document.body.innerHTML = style + '<table>' + document.getElementById(tableID).innerHTML + '</table>';
        window.frames["print_frame"].window.focus();
        window.frames["print_frame"].window.print();
      }
    },
    mounted() {

      this.filter.date = new Date()

  
      if(getItem('report2_start') && getItem('report2_start') !== null && getItem('report2_start') !== 'null' && getItem('report2_start') !== undefined){
        this.filter.date.start = getItem('report2_start')
        this.filter.date.end = getItem('report2_end')
  
        setItem('report2_start',null)
        setItem('report2_end',null)
  
      } else {
        //console.log('asasa')
        this.filter.date.start = new Date()
        this.filter.date.end = new Date()
      }
  
      if(getItem('report_21') && getItem('report_21') !== null && getItem('report_21') !== 'null' && getItem('report_21') !== undefined){
        this.report_new_1 = JSON.parse(getItem('report_21'));
        this.reportTab = 0
  
        setItem('report_21',null)
      }

      if(getItem('report_22') && getItem('report_22') !== null && getItem('report_22') !== 'null' && getItem('report_22') !== undefined){
        this.report_new_2 = JSON.parse(getItem('report_22'));
        this.reportTab = 1
  
        setItem('report_22',null)
      }
  
      if(getItem('report_23') && getItem('report_23') !== null && getItem('report_23') !== 'null' && getItem('report_23') !== undefined){
        this.report_new_3 = JSON.parse(getItem('report_23'));
        this.reportTab = 2
  
        setItem('report_23',null)
      }
  
      if(getItem('report_24') && getItem('report_24') !== null && getItem('report_24') !== 'null' && getItem('report_24') !== undefined){
        this.report_new_4 = JSON.parse(getItem('report_24'));
        this.reportTab = 3
  
        setItem('report_24',null)
      }
  
      if(getItem('report_25') && getItem('report_25') !== null && getItem('report_25') !== 'null' && getItem('report_25') !== undefined){
        this.report_new_5 = JSON.parse(getItem('report_25'));
        this.reportTab = 4
      }
  
      if(getItem('report_26') && getItem('report_26') !== null && getItem('report_26') !== 'null' && getItem('report_2report_162') !== undefined){
        this.report_new_6 = JSON.parse(getItem('report_26'));
        this.reportTab = 5
      }
  
      if(getItem('report_27') && getItem('report_27') !== null && getItem('report_27') !== 'null' && getItem('report_27') !== undefined){
        this.report_new_7 = JSON.parse(getItem('report_27'));
        this.reportTab = 6
      }
  
      // //console.log(getItem('report2_newclient_id'))
      // if(getItem('report2_newclient_id') && getItem('report2_newclient_id') !== null && getItem('report2_newclient_id') !== 'null' && getItem('report2_newclient_id') !== undefined){
      //   this.newclient_id = getItem('report2_newclient_id')
      // }

      if(getItem('report2_nomenclatureList') && getItem('report2_nomenclatureList') !== null && getItem('report2_nomenclatureList') !== 'null' && getItem('report2_nomenclatureList') !== undefined){
        this.nomenclatureList = JSON.parse(getItem('report2_nomenclatureList'));
      }
      if(getItem('report2_managerList') && getItem('report2_managerList') !== null && getItem('report2_managerList') !== 'null' && getItem('report2_managerList') !== undefined){
        this.managerList = JSON.parse(getItem('report2_managerList'));
      }
      if(getItem('report2_clientList') && getItem('report2_clientList') !== null && getItem('report2_clientList') !== 'null' && getItem('report2_clientList') !== undefined){
        this.clientList = JSON.parse(getItem('report2_clientList'));
      }
      if(getItem('report2_uitList') && getItem('report2_uitList') !== null && getItem('report2_uitList') !== 'null' && getItem('report2_uitList') !== undefined){
        this.uitList = JSON.parse(getItem('report2_uitList'));
      }
      if(getItem('report2_report1Detail') && getItem('report2_report1Detail') !== null && getItem('report2_report1Detail') !== 'null' && getItem('report2_report1Detail') !== undefined){
        this.report1Detail = true;
        setItem('report2_report1Detail',null)
        if(getItem('report2_report1DetailData') && getItem('report2_report1DetailData') !== null && getItem('report2_report1DetailData') !== 'null' && getItem('report2_report1DetailData') !== undefined){
          this.report_new_1_detail = JSON.parse(getItem('report2_report1DetailData'));
        }
      }

      this.$store.dispatch(lessonActionTypes.getSpecialistList);

      this.$store.dispatch(lessonActionTypes.getGroupSpecialistList);

      this.$store.dispatch(departmentActionTypes.departmentList).then((result) => {
          if(result){
            this.departmentListDef = result.department
          }
        })

        let org_inn = null
          this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn:org_inn,for_reports:true})
          .then((response) => {
            if(response && response.sales) {
              this.listAllServicesDef = response
            }
          })


          setItem('sale-client',null)
  
    },  
    watch: {
      newclient_id(){
        //console.log(this.newclient_id)
      },
      search() {
        //this.newclient_id = null
        if (this.search !== '' && !this.newclient_id) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search
          })
        }
      },
      search12() {
        //this.newclient_id = null
        if (this.search12 !== '' && !this.newclient_id) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search12
          })
        }
      },
      search13() {
        //this.newclient_id = null
        if (this.search13 !== '' && !this.newclient_id3) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search13
          })
        }
      },
      search22() {
        //this.newclient_id = null
        if (this.search22 !== '' && !this.newclient_id2) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search22
          })
        }
      },
      search14() {
        //this.newclient_id = null
        if (this.search14 !== '' && !this.newclient_id4) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search14
          })
        }
      },
      search15() {
        //this.newclient_id = null
        if (this.search15 !== '' && !this.newclient_id5) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search15
          })
        }
      },
      search16() {
        //this.newclient_id = null
        //console.log(this.search16)
        if (this.search16 !== '' && !this.newclient_id) {
          this.$store.dispatch(clientActionTypes.searchClient, {
            client_field: this.search16
          })
        }
      },
      reportTab() {

        // if(this.reportTab > 0){
    
          
        // }
        

        this.nomenclatureList = []
        this.uitList = []
        this.clientList = []
        this.managerList = []

        this.lastManager = null
        this.lastUit = null
        this.lastStatus = null
        //this.newclient_id = null


        // this.report_new_2 = []
        //this.report_new_3 = []
        // this.report_new_4 = []
        // this.report_new_5 = []
        // this.report_new_6 = []
        // this.report_new_7 = []
        // if (this.reportTab === 3) {
        //   this.report_new_4 = []
  
        //   this.$store.dispatch(reportActionTypes.revenueDivision, {
        //     date_start: this.filter.date.start,
        //     date_end: this.filter.date.end,
        //     client_id:this.newclient_id,
        //     filter:this.filter,
        //     type:4
        //   })
        //   .then((response) => {
        //     if(response && response.success){
        //       this.report_new_4 = response.data
        //       this.isLoadingReport = false
        //     } else {
        //       alert('Данных не найдено!')
        //       this.isLoadingReport = false
        //     }
        //   })
  
          
        //   this.$store.dispatch(departmentActionTypes.departmentList).then((result) => {
        //     if(result){
        //       this.departmentListDef = result.department
        //     }
        //   })
  
  
  
        // }
  
        // if (this.reportTab === 4) {
        //   this.$store.dispatch(lessonActionTypes.getRoomList, {
        //               for_reports: true
        //             })
        //   .then((response) => {
        //     this.rooms_list = response.room
        //     this.rooms_list.unshift({id:null,name:"Все помещения"})
        //   })
        // }
        // if (this.reportTab === 4) {
        //   this.$store.dispatch(reportActionTypes.salesPlanfact, {
        //     date_start: this.date.start,
        //     date_end: this.date.end,
        //   }).then((response) => {
        //     this.headers = response.headers
        //     this.report = response.sales
        //   })
        // }
      },
      select_cashbox(){
        ////console.log(this.select_cashbox)
        
        this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox.serial
          }).then((resp) => {
          ////console.log(resp)
          if(resp && resp.cashbox && resp.cashbox.cashbox) {
  
            this.select_cashbox_id = resp.cashbox.cashbox.id
  
            } else {
  
              alert('Не удалось получить данные по выбранной кассе!')
           }
      })
      }
    }
    }
  </script>
  <style scoped lang="scss">
  .filter {
    &.report-1 {
      width: 100%;
      display: flex;
      align-items: center;
  
      .left {
        flex: 1;
        display: flex;
        align-items: center;
      }
  
      .right {
      }
    }
  
    &.report-3 {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
  
      .item {
        width: 100%;
  
        .v-application .primary--text {
          color: #767676 !important;
          caret-color: #767676 !important;
  
        }
      }
    }
  }
  
  .custom__date-button {
    width: 230px;
    height: 23px;
    display: flex;
    padding: 7px;
    max-width: 230px;
    position: relative;
    box-sizing: content-box;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0;
    border-radius: 12px;
    margin-bottom: 0;
    justify-content: center;
    background-color: var(--dl-color-default-primarysuccess) !important;
    font-size: 16px;
    line-height: 24px;
    color: #fff !important;
  }
  
  .special-light-button {
    box-shadow: none;
    border-radius: 12px;
    color: #1A1A1A;
    text-transform: none;
    font-size: 13px;
    line-height: 16px;
  
    img {
      margin-right: 9.33px;
    }
  }
  
  .border-gray {
    border: 1px solid #E0E0E0 !important;
  
  }
  
  .scroll-table {
    overflow-x: auto;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    scrollbar-width: thin;
    scrollbar-color: #E0E0E0 #fff;
    border-bottom: 1px solid #E0E0E0;
  
    &::-webkit-scrollbar {
      height: 12px;
      background: #E0E0E0;
    }
  
    &::-webkit-scrollbar-track {
      background: #fff;
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: #E0E0E0;
      border-radius: 8px;
      border: 2px solid #fff;
    }
  
    table {
      border-collapse: collapse;
      transform: rotateX(180deg);
      -ms-transform: rotateX(180deg);
      -webkit-transform: rotateX(180deg);
      min-width: 100%;
  
      &#table-3 {
        min-width: 100%;
  
        .td-check {
          div {
            display: flex;
            align-items: center;
  
            svg {
              margin-right: 10px;
            }
          }
        }
  
        .td-client {
          div {
            white-space: nowrap;
            display: flex;
            align-items: center;
  
            .ava {
              width: 24px;
              min-width: 24px;
              max-width: 24px;
              height: 24px;
              min-height: 24px;
              max-height: 24px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 8px;
  
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
        }
      }
  
      &#table-4 {
        width: 100%;
      }
  
      th {
        vertical-align: top;
      }
  
      th,
      td {
        background: #fff;
        padding: 10px 12px;
        text-align: left;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #000000;
        border: 1px solid #E0E0E0 !important;
  
        &.font-bold {
          font-weight: bold;
        }
  
        &.no-wrap {
          white-space: nowrap;
        }
  
        &:first-child {
          border-left: 0 !important;
        }
  
        &:last-child {
          border-left: 0 !important;
        }
  
        .open-hide {
          border: 1px solid #1A1A1A;
          width: 12px;
          height: 12px;
          display: flex;
          justify-content: center;
          border-radius: 2px;
  
          &::after {
            content: "+";
            line-height: 12px;
          }
  
          &.open {
            align-items: center;
  
            &::after {
              content: "";
              display: block;
              height: 1px;
              background: #1A1A1A;
              width: 6px;
              border-radius: 1px;
              line-height: 10px;
            }
          }
        }
      }
  
      tbody {
        tr {
          &.parrent {
            td {
              background: #F1F1F1;
            }
          }
  
          &:last-child {
            td {
              border-bottom: 0 !important;
            }
          }
        }
      }
    }
  }
  </style>